import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import homePageService from "services/HomePageService";
import { message } from "antd";

export const initialState = {
  loadingAllData: false,
  loadingActivate: false,
  getAllData: [],
  createLoading: false,
  updateLoading: false,
  loadingGetByIdData: false,
  getByIdData: {},
  loadingOrder: false,
};

export const Create = createAsyncThunk(
  "/HomePageNumber/Create",
  async (data, { rejectWithValue }) => {
    try {
      const response = await homePageService.Create(data);
      if (response.success === false) {
        message.warning({
          content: ` ${response.message}`,
        });
        return rejectWithValue(response.message);
      } else {
        message.success({
          content: ` ${response.message}`,
        });

        return response;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const Update = createAsyncThunk(
  "/HomePageNumber/Update",
  async (data, { rejectWithValue }) => {
    try {
      try {
        const response = await homePageService.Update(data);

        if (response.success === false) {
          message.warning({
            content: ` ${response.message}`,
          });
          return rejectWithValue(response.message);
        } else {
          message.success({
            content: ` ${response.message}`,
          });

          return response;
        }
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message || "Something Went Wrong !"
        );
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetById = createAsyncThunk(
  "/HomePageNumber/GetById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await homePageService.GetById({ id });

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetAll = createAsyncThunk(
  "/HomePageNumber/GetAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await homePageService.GetAll();

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const Activate = createAsyncThunk(
  "/HomePageNumber/Activate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await homePageService.Activate(data);
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return rejectWithValue(response.message);
      } else {
        message.success({
          content: ` ${response.message}`,
        });
      }
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);
export const ChangeOrder = createAsyncThunk(
  "/HomePageNumber/ChangeOrder",
  async (data, { rejectWithValue }) => {
    try {
      const response = await homePageService.ChangeOrder(data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const homePageSlice = createSlice({
  name: "homePage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(Create.pending, (state) => {
        state.createLoading = true;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.createLoading = false;
      })
      .addCase(Create.rejected, (state, action) => {
        state.createLoading = false;
      })

      .addCase(Update.pending, (state) => {
        state.updateLoading = true;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.updateLoading = false;
      })
      .addCase(Update.rejected, (state, action) => {
        state.updateLoading = false;
      })
      .addCase(GetAll.pending, (state) => {
        state.loadingAllData = true;
      })

      .addCase(GetAll.fulfilled, (state, action) => {
        state.loadingAllData = false;
        state.getAllData = action.payload;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.loadingAllData = false;
        state.getAllData = [];
      })
      .addCase(Activate.pending, (state) => {
        state.loadingActivate = true;
      })
      .addCase(Activate.fulfilled, (state, action) => {
        state.loadingActivate = false;
      })
      .addCase(Activate.rejected, (state, action) => {
        state.loadingActivate = false;
      })
      .addCase(ChangeOrder.pending, (state) => {
        state.loadingOrder = true;
      })
      .addCase(ChangeOrder.fulfilled, (state, action) => {
        state.loadingOrder = false;
      })
      .addCase(ChangeOrder.rejected, (state, action) => {
        state.loadingOrder = false;
      });
  },
});

export const {} = homePageSlice.actions;

export default homePageSlice.reducer;
